import { DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI } from '../../../types/default-cloud-graph-calendar-event-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import {
	OutlookCalendarIcon,
	OutlookCalendarIconBorderless,
	OutlookCalendarSearchResultIcon,
} from './icon';

export const outlookCalendarConfig: ThirdPartyConfig = {
	displayName: 'Outlook Calendar',
	id: 'outlook-calendar',
	resourceType: ProductResourceTypes3P.OutlookCalendar,
	icon: get3PLogo(OutlookCalendarIcon, 'Outlook Calendar', 'medium'),
	iconBorderless: get3PLogo(OutlookCalendarIconBorderless, 'Outlook Calendar', 'small'),
	searchResultIcon: get3PLogo(OutlookCalendarSearchResultIcon, 'Outlook Calendar', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Calendar,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
